import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import DemographicDoubleComparisionDetail from './DemographicDoubleComparisionDetail';

class DemographicsDoubleComparisionPersona extends Component {
  constructor(props) {
    super(props);
    this.state = { };
  }

  render() {
    const demographicsList = [];
    if (this.props.demographics !== undefined) {
      _.each(this.props.demographics, demographic => {
        demographicsList.push({
          demographicsInfo: demographic,
          detailsGroupsList: demographic.detailGroups,
        });
      });
    }
    return (
      <div className="row fullwidth demoCardPdf">
        <div className="row fullwidth demographic-detail-columns">
          {!_.isEmpty(demographicsList) &&
            demographicsList.length > 0 &&
            demographicsList.map((demographic, index) => (
              <div key={index}>
                <div className="columns large-6 medium-6 small-6 demographicsDoublePersonaPdf">
                  {demographic.detailsGroupsList.map((demoDetail, i) => (
                    <div
                      className="row fullwidth demographic-detail-columns"
                      key={`demo-d${index}${i}`}
                    >
                      <div
                        className="columns large-12 small-12 medium-12"
                        id="pdfDemoDoublePersonaGridLenght"
                      >
                          <DemographicDoubleComparisionDetail
                            key={demoDetail.name}
                            demoDetail={demoDetail}
                            personaIndex={index}
                            selectedTab={this.props.selectedTab}
                          />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

DemographicsDoubleComparisionPersona.propTypes = {
  demographics: PropTypes.arrayOf(PropTypes.object),
  selectedTab: PropTypes.string,
};

function mapStateToProps() {
  return {
    // demographics: state.insight360.demographics
  };
}

function mapDispatchToProps() {
  return {
    // brand360Actions: bindActionCreators(brand360Actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(DemographicsDoubleComparisionPersona);
